import React, { useEffect, useState } from "react";

export default function OfferCarousel({ offers = [] }) {
  const [idx, setIdx] = useState(0);
  const list = offers.length ? offers : [];

  useEffect(() => {
    if (list.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % list.length), 4500);
    return () => clearInterval(t);
  }, [list.length]);

  if (!list.length) return null;

  return (
    <div className="relative w-full overflow-hidden rounded-2xl bg-neutral-100" data-testid="offers-carousel">
      <div
        className="flex carousel-slide"
        style={{ transform: `translateX(-${idx * 100}%)` }}
      >
        {list.map((o, i) => (
          <div key={o.offer_id || i} className="min-w-full aspect-[21/6] sm:aspect-[24/6] relative">
            <img
              src={o.image_url}
              alt={o.title}
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            <div className="absolute bottom-0 left-0 p-6 text-white">
              <h3 className="font-display text-2xl md:text-3xl font-extrabold">{o.title}</h3>
              {o.subtitle && <p className="mt-1 text-sm md:text-base opacity-90 max-w-sm">{o.subtitle}</p>}
              {o.discount_pct ? (
                <span className="inline-block mt-3 text-xs font-bold uppercase tracking-wider bg-white text-black rounded-full px-3 py-1">
                  -{o.discount_pct}%
                </span>
              ) : null}
            </div>
          </div>
        ))}
      </div>
      <div className="absolute bottom-3 right-3 flex gap-1.5">
        {list.map((_, i) => (
          <button
            key={i}
            onClick={() => setIdx(i)}
            className={`h-1.5 rounded-full transition-all ${i === idx ? "w-6 bg-white" : "w-1.5 bg-white/50"}`}
            data-testid={`carousel-dot-${i}`}
            aria-label={`slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
